import { getConstructionData_listUserSaleContracts_construction_constructionSpecificAddress } from '../../../services/types/getConstructionData'

export const getAddressToDisplay = (
  constructionAddress: getConstructionData_listUserSaleContracts_construction_constructionSpecificAddress
): string => {
  const street = constructionAddress?.street ?? ''
  const district = constructionAddress?.district ?? ''
  const city = constructionAddress?.city ?? ''
  const federatedUnit = constructionAddress?.federatedUnit ?? ''
  const streetAndDistrict = street && district ? `${street} - ${district}` : `${street}${district}`
  const cityAndFederalUnit = city && federatedUnit ? `${city} - ${federatedUnit}` : `${city}${federatedUnit}`

  return `${streetAndDistrict} \n${cityAndFederalUnit}`
}
